import { i18nResponseDto } from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { areEqualAttributes } from './helpers';
import { getAttributes } from '../shared/helpers';

export const generateAttributesPayload = (
  originalAttributes,
  newAttributes,
  language: LanguagesType,
): { attributes: i18nResponseDto[] } | undefined => {
  if (newAttributes === undefined) {
    return undefined;
  }
  if (areEqualAttributes(originalAttributes, newAttributes, language)) {
    return undefined;
  }
  // Explicitly clear all attributes when attributes is empty
  if (newAttributes.length === 0) {
    return { attributes: [] };
  }

  return getAttributes(language, newAttributes);
};
